import { Column, TableInstance } from "react-table";
import { Lookup } from "../../../../models/Configuration";
import { useCallback, useMemo, useState } from "react";
import { SelectColumnFilter } from "../../../../components/table/filters/SelectColumnFilter";
import { Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactTable } from "../../../../components/table/ReactTable";
import { convertValue } from "../../../../helpers/utils/valueConverter";
import { apiStore } from "../../../../api/ApiFactory";

const LookupTableComponent = ({ data, name, value }: any) => {

    const navigate = useNavigate();
    const [isLocked, setIsLocked] = useState<boolean>(true);

    const handleToggle = useCallback(
        (instance: TableInstance<Lookup>) => () => {
            setIsLocked(prevState => !prevState);
        },
        []
    );

    const onAdd = useCallback(
        (instance: TableInstance) => () => {

            navigate("option/add", {
                state: { option: { name: name, key: value, data: null } }
            })

        }, []
    );

    const onEdit = useCallback(
        (instance: TableInstance) => () => {

            const option = instance.selectedFlatRows[0].original;
            navigate("option/edit", {
                state: { option: { name: name, key: value, data: option } }
            })

        }, []
    );


    const lookupColumns: Column<Lookup>[] = useMemo(
        () => [
          {
            Header: "Name",
            accessor: "name",
          },
          {
              Header: "Display Name",
              accessor: "displayName",
              InLineEdit: true,
              inputType: 'text',
          },
          {
            Header:"Description",
            accessor: "description",
            InLineEdit: true,
            inputType: 'text',
          },
          {
            Header: "Is Active",
            accessor: "isActive",
            InLineEdit: true,
            inputType: 'checkbox',
            Filter: SelectColumnFilter,
            Cell: (cell: any) => (
              <Checkbox
                className="row-checkbox"
                disabled={true}
                checked={cell.value ? true : false}
              />
            ),
          },
          {
            Header: "Order",
            accessor: "order",
            InLineEdit: true,
            inputType: 'text',
          }
        ],
        []
    );

    const updateRowOriginal = (row: any, columnId: any, newValueConverted: any) => {
        switch (columnId) {
            case "description":
                row.original.description = newValueConverted;
                break;
            case "displayName":
                row.original.displayName = newValueConverted;
                break;
            case "isActive":
                row.original.isActive = newValueConverted;
                break;
            case "order":
                row.original.order = newValueConverted;
                break;
            default:
                console.warn(`No update case for columnId: ${columnId}`);
                break;
        }
    };

    const onInlineEdit = useCallback(
        async (rowId: string | number, columnId: string, newValue: any, instance: TableInstance<Lookup>) => {
            const row = instance.rows.find(row => row.original.id === rowId);

            if (row) {
                const oldValue = row.values[columnId];
                const newValueConverted = convertValue(oldValue, newValue);;

                // Only update if the new value is different from the old value
                if (oldValue !== newValueConverted) {
                    const updatedValues: Lookup = {
                        ...row.original,
                        [columnId as keyof Lookup]: newValue,
                    };

                    try {
                        let result = null;
                        if (instance.name == "Requested Delivery")
                            result = await apiStore.lookupApi.saveDeliveryMethod(updatedValues);
                        else if (instance.name == "Shipping")
                            result = await apiStore.lookupApi.saveFreightMethod(updatedValues);

                        if (result) {
                            row.values[columnId] = newValueConverted;
                            updateRowOriginal(row, columnId, newValueConverted);
                        }
                    }
                    catch (error) { console.error(error); }
                } else {
                    console.log('No change detected. Update skipped.');
                }
            } else {
                console.error('Row not found:', rowId);
            }
        },
        []
    );

      return (
        <ReactTable
            name={name}
            columns={lookupColumns}
            data={data ? data : []}
            onEdit={onEdit}
            onAdd={onAdd}
            isLoading={false}
            inlineLock={handleToggle}
            inlineLockState={isLocked}
            onInlineEdit={onInlineEdit}
            initialFilters={
              [{
                id: "isActive",
                value: "true"
              }]
            }
          />
      ) 
}


export default LookupTableComponent;